import { ButtonForm, CustomTextField } from 'Components/Form/styles';
import { Column, Row } from 'Components/Grid';
import { useNavigate } from 'react-router-dom';

export const Detalhes = ({ handleComplete, register, handleSubmit, errors }) => {
  // const theme = useTheme()
  const navigate = useNavigate();
  const onSubmit = () => {
    handleComplete();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="w-100">
      <Row>
        <Column xs={12} xl={4} className="d-flex">
          <div data-tour="office-name" style={{ width: '100%' }}>
          <CustomTextField
            {...register('name', { required: 'Nome é obrigatório' })}
            label="Nome"
            autoFocus
            error={errors?.name ? true : false}
            sx={{ minHeight: '48px', margin: '0 auto 24px', width: '100%' }}
            helperText={errors?.name ? errors.name.message : null}
            InputLabelProps={{ shrink: true }}
          />
          </div>
        </Column>
        <Column xs={12} xl={4} className="d-flex">
          <div data-tour="office-address" style={{ width: '100%' }}>
          <CustomTextField
            {...register('address')}
            label="Endereço"
            // error={errors?.name ? true : false}
            sx={{ minHeight: '48px', margin: '0 auto 24px', width: '100%' }}
            // helperText={errors?.name ? errors.name.message : null}
            InputLabelProps={{ shrink: true }}
          />
          </div>
        </Column>
        <Column xs={12} xl={4} className="d-flex">
          <div data-tour="office-phone" style={{ width: '100%' }}>
          <CustomTextField
            {...register('phone')}
            label="Telefone"
            // error={errors?.name ? true : false}
            sx={{ minHeight: '48px', margin: '0 auto 24px', width: '100%' }}
            // helperText={errors?.name ? errors.name.message : null}
            InputLabelProps={{ shrink: true }}
          />
          </div>
        </Column>
      </Row>
      <div data-tour="form-actions">
      <Row justifyContent="end" alignItems="center">
        <Column xs={4} xl={3} className="d-flex" style={{ gap: '8px', justifyContent: 'flex-end' }}>
          <ButtonForm secondary id="cancel" label="cancelar" onClick={() => navigate('/offices')}></ButtonForm>
          <ButtonForm label="Salvar" type="submit" />
        </Column>
      </Row>
      </div>
    </form>
  );
};
